import template from 'size-guide/pdp-modal.j2';
import { generate } from '@core/js/utils/componentUtils';
import addAccordionSupport from '@core/js/uiSupport/accordion';
import { handleUtagEvent } from '@core/js/actions/initialActions';
import { getDefaultOptions } from '@core/js/utils/a15componentUtils';
import {
    changeSizeGuideConversionSaga,
    changeSizeGuideFitSaga
} from '@product/js/sagas/sizeGuideSagas';
import { updateSizeGuideMeasurementUnit } from '@product/js/actions/sizeGuideActions';

function resetSizeGuideWebview() {

    if (window.isSizeGuideWebview) {
        window.isSizeGuideWebview = false;
    }
}

function handleSizeGuideAnalytics(store, eventType, eventSelection) {
    const state = store.getState();
    const selectedFit = _.get(state, 'product.sizeGuide.selectedFit.displayName', null);
    const selectedConversion = _.get(state, 'product.sizeGuide.selectedConversion.country', null);
    const selectedMeasurementUnit = _.get(state, 'product.sizeGuide.selectedUnit', null);

    const utagLinkData = {
        "event_category": 'size guide',
        "event_action": `${selectedFit} | ${selectedConversion} | ${selectedMeasurementUnit}`,
        "event_label": `${eventType} ${eventSelection}`
    };
    store.dispatch(handleUtagEvent(utagLinkData, 'link'));
}

function attachEvents(store) {
    $(document).on(this.scopedEvent('change'), this.scopedSelector('.js-conversion-select'), (e) => {
        const state = store.getState();
        this.attachLoader(store);

        const newConversion = e.target.value;
        const newConversionText = _.get(e.target, `options[${e.target.selectedIndex}].text`, null);

        handleSizeGuideAnalytics(store, 'country click', newConversionText);
        store.runSaga(changeSizeGuideConversionSaga, state, newConversion).done.then(() => this.removeLoader());
    });

    $(document).on(this.scopedEvent('change'), this.scopedSelector('.js-side-guide-measurement-unit-select'), (e) => {
        const newMeasurementUnit = e.target.value;

        handleSizeGuideAnalytics(store, 'measurement click', newMeasurementUnit);
        store.dispatch(updateSizeGuideMeasurementUnit(newMeasurementUnit));
    });

    $(document).on(this.scopedEvent('click'), this.scopedSelector('.js-fit-select'), (e) => {
        const state = store.getState();
        e.preventDefault();
        this.attachLoader(store);

        const newFit = e.target.value;
        const newFitText = e.target.name;

        handleSizeGuideAnalytics(store, 'fit click', newFitText);
        store.runSaga(changeSizeGuideFitSaga, state, newFit).done.then(() => this.removeLoader());
    });

    $(document).on('click', `${this.templateLocation} .js-accordion-tab`, (e) => {
        const tabSet = $(e.target).closest('.js-accordion-tabset');
        const tabAction = tabSet.hasClass('is-collapsed') ? 'collapse' : 'expand';

        handleSizeGuideAnalytics(store, 'measurement guide', tabAction);
    });
}

function firstRender(store) {
    this.render(store, this);
}

function afterRender(store) {
    addAccordionSupport(this, this.templateLocation);
}

export function init(store, overrides = {}) {
    const config = {
        templateLocation: '.dom-size-guide',
        attachEvents: attachEvents,
        firstRender: firstRender,
        afterRender: afterRender,
        jsAccordionClass: '.js-accordion',
        watch: 'product.sizeGuide',
        template: template,
        name: 'modal.sizeGuide',
        replace: 'once',
        afterXCloseAction: resetSizeGuideWebview,
        loader: {}
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
